import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export const EMOJI_PICKER_TRIGGER_CHARACTER = ':';

export default function emojiPickerPluginTrigger(evt: PluginEvent, editor: Editor) {
    if (evt.eventType === PluginEventType.KeyPress) {
        let keyboardEvent = evt.rawEvent as KeyboardEvent;
        return keyboardEvent.key == EMOJI_PICKER_TRIGGER_CHARACTER;
    }
    return false;
}
